

















































































import { Component, Vue, Prop, Emit } from "vue-property-decorator";
import { CajaChicaSantiagoOF } from "@/typings/store/plugins/easyFirestore/cajaChicasSantiagoOF";

@Component({})
export default class InfoCajaChicaSantiagoOF extends Vue {
  @Prop() readonly cajaChicaSantiagoOF!: CajaChicaSantiagoOF;
  @Prop({ type: Boolean }) readonly showTitulo!: boolean;

  get numero(): string {
    return this.cajaChicaSantiagoOF.numero?.toString() ?? "N/R";
  }

  get fecha(): string {
    const f = this.cajaChicaSantiagoOF.fecha;
    if (typeof f === "string") return f || "N/R";
    if (f && typeof (f as { toDate?: () => Date }).toDate === "function") {
      return (f as { toDate: () => Date }).toDate().format?.("DD-MM-YYYY") ?? "N/R";
    }
    return "N/R";
  }

  get rutProveedor(): string {
    return this.cajaChicaSantiagoOF.rutProveedor ?? "N/R";
  }

  get nombreProveedor(): string {
    return this.cajaChicaSantiagoOF.nombreProveedor ?? "N/R";
  }

  get accion(): string {
    return this.cajaChicaSantiagoOF.accion ?? "N/R";
  }

  get ingresoFormateado(): string {
    const v = this.cajaChicaSantiagoOF.ingreso;
    if (v === undefined || v === null || v === "") return "-";
    const num = typeof v === "string" ? parseFloat(String(v).replace(/\./g, "").replace(",", ".")) : Number(v);
    if (Number.isNaN(num)) return "-";
    return "$ " + Math.round(num).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  }

  get egresoFormateado(): string {
    const v = this.cajaChicaSantiagoOF.egreso;
    if (v === undefined || v === null || v === "") return "-";
    const num = typeof v === "string" ? parseFloat(String(v).replace(/\./g, "").replace(",", ".")) : Number(v);
    if (Number.isNaN(num)) return "-";
    return "$ " + Math.round(num).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  }

  get documento(): string {
    return this.cajaChicaSantiagoOF.documento ?? "N/R";
  }

  get concepto(): string {
    return this.cajaChicaSantiagoOF.concepto ?? "N/R";
  }

  get descripcion(): string {
    return this.cajaChicaSantiagoOF.descripcion ?? "N/R";
  }

  textoAutor(quien?: string, cuando?: string): string {
    const partes = [quien, cuando].filter((parte) => !!parte);
    return partes.join(" · ");
  }

  get registroTexto(): string {
    const texto = this.textoAutor(this.cajaChicaSantiagoOF.creadoPor, this.cajaChicaSantiagoOF.creadoEn);
    return texto || "Sin registro";
  }

  get edicionTexto(): string {
    return this.textoAutor(this.cajaChicaSantiagoOF.editadoPor, this.cajaChicaSantiagoOF.editadoEn);
  }

  get archivo(): { url?: string; file?: File } | null {
    const arch = this.cajaChicaSantiagoOF.archivo;
    if (!arch || typeof arch !== "object") return null;
    const first = Object.values(arch)[0];
    return first ?? null;
  }

  get tieneComprobante(): boolean {
    return !!(this.archivo && (this.archivo.url || this.archivo.file));
  }

  get urlComprobante(): string {
    const a = this.archivo;
    if (!a) return "";
    if (a.url) return a.url;
    if (a.file) return URL.createObjectURL(a.file);
    return "";
  }

  @Emit("cerrar")
  onCerrar(): void {
    return;
  }
}
